import { Clock, X } from 'lucide-react';
import { BookingDetails, DrawerTab } from '../../types/booking-details.types';
import { STATUS_CONFIG, DRAWER_TABS } from '../../constants/booking-details.constants';
import { cn } from '../../lib/utils';

export function DrawerHeader({
  booking,
  activeTab,
  setActiveTab,
  onClose,
}: {
  booking: BookingDetails;
  activeTab: DrawerTab;
  setActiveTab: (tab: DrawerTab) => void;
  onClose: () => void;
}) {
  return (
    <>
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-5 border-b border-slate-200 bg-white shrink-0 rounded-t-2xl">
        <div className="flex items-center gap-4">
          <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center font-bold text-lg">
            {booking.client.name.charAt(0)}
          </div>
          <div>
            <div className="flex items-center gap-3">
              <h2 id="modal-title" className="text-lg font-bold text-slate-900">
                {booking.ref}
              </h2>
              <div className="flex items-center gap-2">
                <span
                  className={cn(
                    'px-2.5 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wide',
                    STATUS_CONFIG[booking.status]?.bg,
                    STATUS_CONFIG[booking.status]?.text,
                  )}
                >
                  {STATUS_CONFIG[booking.status]?.label}
                </span>
                {booking.isUrgent && (
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wide bg-red-600 text-white animate-pulse">
                    <Clock className="w-3 h-3" />
                    URGENT - 48H
                  </span>
                )}
              </div>
            </div>
            <p className="text-sm text-slate-500 mt-0.5">
              {booking.client.name} · Créée le {booking.createdAt}
            </p>
          </div>
        </div>
        <button
          onClick={onClose}
          className="p-2 text-slate-400 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
          aria-label="Fermer"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Tabs */}
      <div className="px-6 border-b border-slate-200 bg-white shrink-0">
        <div className="flex gap-1">
          {DRAWER_TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                'flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors -mb-px',
                activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-slate-500 hover:text-slate-900 hover:border-slate-300',
              )}
            >
              <tab.icon className="w-4 h-4" />
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
